export const file = {
  restrictions: 'Restrictions',
  maxFileSize: 'Maximum file size',
  maxFiles: 'Maximum number of files',
  allowedTypes: 'Allowed file extensions',
  noFile: 'No file',
  fileAdded: 'File uploaded successfully',
  invalidFileType: 'Invalid file type.',
}
